import { Grid2 } from "@mui/material";
//styles
import styles from "./LocationDetails.module.scss";
import CustomInput from "../../../../../../../GlobalComponents/CustomInput/CustomInput";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
// Icons
import { ReactComponent as Usa } from "../../../../../../../GlobalAssets/svg/UsaSvg.svg";
import { ReactComponent as Indian } from "../../../../../../../GlobalAssets/svg/IndianSvg.svg";

function LocationDetails({ loggedInUserInfoDB }) {
  return (
    <>
      <Grid2 className={styles.LocationDetailsMainContainer}>
        <Grid2 className={styles.flexBox}>
          <Grid2 className={styles.Icon}>
            <PinDropOutlinedIcon className={styles.IconColor} />
          </Grid2>
          <Grid2 className={styles.Header}>Location</Grid2>
        </Grid2>
        <Grid2 className={styles.InputFlexBox}>
          <CustomInput
            title="Address"
            placeholder="Enter Address"
            value={loggedInUserInfoDB?.address}
            disabled={true}
          />
        </Grid2>
        <Grid2 className={styles.InputFlexBox}>
          <Grid2 className={styles.InputWidth}>
            <CustomInput
              title="Country"
              placeholder="Enter Country"
              frontEndorment={
                loggedInUserInfoDB?.country === "USA" ? <Usa /> : <Indian />
              }
              value={loggedInUserInfoDB?.country}
              disabled={true}
            />
          </Grid2>
          <Grid2 className={styles.InputWidth}>
            <CustomInput
              title="State"
              placeholder="Enter State"
              value={loggedInUserInfoDB?.state}
              disabled={true}
            />
          </Grid2>
        </Grid2>
        <Grid2 className={styles.InputFlexBox}>
          <Grid2 className={styles.InputWidth}>
            <CustomInput
              title="City"
              placeholder="Enter City"
              value={loggedInUserInfoDB?.city}
              disabled={true}
            />
          </Grid2>
          <Grid2 className={styles.InputWidth}>
            <CustomInput
              title="Zip code"
              placeholder="Enter Zip code"
              value={loggedInUserInfoDB?.zipCode}
              disabled={true}
            />
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}

export default LocationDetails;
